import {HttpWrapperOptions, httpService} from '../../httpWrapper';
import {getApiRoute} from '../../pipes';
import {
  CounterpartyLinkedProfile,
  linkedAccountToken,
  requestForLinkingId,
  requestIdentificator,
  requestLinkAccountType,
} from './Types';
import {accountLinkerUrls} from './apiUrls';

// CounterpartyLinkedProfiles (GET) - список привязанных аккаунтов по текущему авторизованному
// пользователю, в выходных данных поля следующие: Id (ID связки), CounterpartyFullName, Status, CreatedAt
export const getLinkedProfiles = async () => {
  const data = await httpService.get<CounterpartyLinkedProfile[]>(
    getApiRoute(accountLinkerUrls.getLinkedProfiles),
    new HttpWrapperOptions().Errors(true).ThrowException(true).Wait(true),
  );
  return data;
};
// CounterpartyLinkedProfile/{parameter} (POST) - поиск держателя и создание запроса на
// привязку аккаунта (где parameter - номер ЕСК или снилс для поиска держателя), данный эндпоинт
// должен отправлять пуш пользователю на привязку
// {"counterpartyLinkedProfileId":2}
export const requestLinkAccount = async (requestedAccount: requestIdentificator) => {
  return await httpService.post<requestLinkAccountType>(
    getApiRoute(accountLinkerUrls.requestLinkToCounterpartyProfile, {identificator: requestedAccount}),
    new HttpWrapperOptions().Errors(true).ThrowException(true).Wait(true),
  );
};
// AcceptForCounterpartyLinkProfile/{counterpartyLinkedProfileId} (PUT) - подтверждение
// привязки, в параметре передается айди запроса на привязку (из предыдущего эндпоинта он приходит в ответе)
// {"counterpartyLinkedProfileId":2}
export const acceptRequestForLinking = async (requestId: requestForLinkingId) => {
  await httpService.put(
    getApiRoute(accountLinkerUrls.acceptRequestForLinking, {requestForLinkingId: requestId}),
    new HttpWrapperOptions().Errors(true).ThrowException(true).Wait(true),
  );
};
// DeclineForCounterpartyLinkProfile/{counterpartyLinkedProfileId} (DELETE) -
// удаление привязки в одностороннем порядке, в параметре так же передается айди привязки
// {"counterpartyLinkedProfileId":2}
export const declineRequestForLinking = async (requestId: requestForLinkingId) => {
  await httpService.delete(
    getApiRoute(accountLinkerUrls.declineRequestForLinking, {requestForLinkingId: requestId}),
    new HttpWrapperOptions().Errors(true).ThrowException(true).Wait(true),
  );
};
// GiveAuthorizationTokenForLinkedProfile/{counterpartyLinkedProfileId} (POST) -
// выдача (подмена) jwt токена для родительского аккаунта
// {"counterpartyLinkedProfileId":2}
export const getTokenForLinkedAccount = async (requestId: requestForLinkingId) => {
  const linkedAccountJwtToken = await httpService.post<linkedAccountToken>(
    getApiRoute(accountLinkerUrls.getTokenForLinkedAccount, {requestForLinkingId: requestId}),
    new HttpWrapperOptions().Errors(true).ThrowException(true).Wait(true),
  );
  return linkedAccountJwtToken;
};
